import React from 'react';
import PropTypes from 'prop-types';

const AppStateCtx = React.createContext({
  sector: 'pilates',
  setSector: () => {},
});

export function AppStateProvider({ children }) {
  const [sector, setSector] = React.useState('pilates');
  const value = React.useMemo(() => ({ sector, setSector }), [sector]);
  return <AppStateCtx.Provider value={value}>{children}</AppStateCtx.Provider>;
}

AppStateProvider.propTypes = { children: PropTypes.node.isRequired };

export function useAppState() {
  return React.useContext(AppStateCtx);
}
